<template>
  <div class="product-manage">
    <div class="top-area">
      <el-row :gutter="38">
        <el-col :span="6" :xs="24">
          <div class="item">
            <div class="value">
              <span>{{ stat.submit_num || 0 }}</span
              >个
            </div>
            <div class="label">我提交的产品数</div>
            <div class="r-img">
              <img class="bg-img" :src="circleBlue" />
            </div>
          </div>
        </el-col>
        <el-col :span="6" :xs="24">
          <div class="item">
            <div class="value">
              <span>{{ stat.passed_num || 0 }}</span
              >个
            </div>
            <div class="label">已通过的产品数</div>
            <div class="r-img">
              <img class="bg-img" :src="circleOrange" />
            </div>
          </div>
        </el-col>
        <el-col :span="6" :xs="24">
          <div class="item">
            <div class="value">
              <span>{{ stat.deny_num || 0 }}</span
              >个
            </div>
            <div class="label">已驳回的产品数</div>
            <div class="r-img">
              <img class="bg-img" :src="circlePurple" />
            </div>
          </div>
        </el-col>
        <el-col :span="6" :xs="24">
          <div class="item">
            <div class="value">
              <span>{{ stat.audit_num || 0 }}</span
              >个
            </div>
            <div class="label">审核中的产品数</div>
            <div class="r-img">
              <img class="bg-img" :src="circleGreen" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="query-area">
      <el-input style="width: 350px" v-model.trim="keyword" placeholder="请输入产品名称/公司名称" />
      <el-select style="width: 250px" v-model="status" placeholder="审核状态" clearable="">
        <el-option v-for="item in statusOptions" :key="item.status" :label="item.label" :value="item.status">
        </el-option>
      </el-select>
      <el-button style="width: 132px; border-color: #2F9EFF; color: #2F9EFF; background: #fff;" @click="getProductList">
        查询
      </el-button>
      <el-button v-if="canproductAdd" @click="addProduct" type="primary">新增产品名称</el-button>
    </div>
    <div class="table-area">
      <el-table v-if="canproductList" border :data="tableData" v-loading="tableLoading" header-row-class-name="table-header">
        <el-table-column
          v-for="item in tableColumns"
          :key="item.key"
          align="center"
          :label="item.name"
          :prop="item.key"
          :min-width="item.summaryWidth ? item.summaryWidth : 130"
        >
          <template slot-scope="scope">
            <!-- 产品名 -->
            <span v-if="item.key === 'product_name'">
              <el-tag class="tag" type="success">{{ scope.row.product_name }}</el-tag>
            </span>
            <!-- 审核状态 -->
            <span v-else-if="item.key === 'status'">
              <el-tag v-if="scope.row.status === REVIEW_STATUS_ENUM.DELETE" class="danger" effect="dark" type="info"
                >已删除</el-tag
              >
              <el-tag v-if="scope.row.status === REVIEW_STATUS_ENUM.DOING" class="danger" effect="plain" type="danger"
                >审核中</el-tag
              >
              <el-tag v-if="scope.row.status === REVIEW_STATUS_ENUM.PASS" class="tag" type="success">通过</el-tag>
              <el-tag v-if="scope.row.status === REVIEW_STATUS_ENUM.REJECT" class="danger" effect="dark" type="danger"
                >驳回</el-tag
              >
            </span>
            <!-- 资质证明 -->
            <span v-else-if="item.key === 'qualification'">
              <span v-if="scope.row.qualification">
                <div v-for="item in scope.row.qualification.split(',')" :key="item" :style="qualificationStyle(item)" />
              </span>
            </span>
            <span v-else>
              {{ scope.row[item.key] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status === REVIEW_STATUS_ENUM.PASS">
              <el-button type="text" @click="addAdvertiser">添加客保</el-button>
            </span>
            <span v-else>
              <el-button v-if="canproductEdit" type="text" @click="modifyProduct(scope.row)">修改</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handlePaginationSizeChange"
        @current-change="handlePaginationCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="total"
      />
    </div>
    <product-dialog
      ref="producutDialog"
      title="新增产品信息"
      confirmText="提交"
      @submit="submitProduct"
      :visible.sync="showProductModifyDialog"
    >
      <el-form :model="productForm" ref="productForm" label-width="130px">
        <el-form-item
          label="产品名称"
          prop="product_name"
          :rules="[
            {
              required: true,
              message: '名称不能为空'
            }
          ]"
        >
          <el-input type="text" v-model="productForm.product_name"></el-input>
        </el-form-item>
        <el-form-item
          label="应用市场链接"
          prop="product_url"
          :rules="[
            {
              required: true,
              message: '链接不能为空'
            }
          ]"
        >
          <el-input v-model="productForm.product_url"></el-input>
        </el-form-item>
        <el-form-item
          label="公司名称"
          prop="product_company"
          :rules="[
            {
              required: true,
              message: '链接不能为空'
            }
          ]"
        >
          <el-input v-model="productForm.product_company"></el-input>
        </el-form-item>
        <el-form-item label="资质证明" prop="qualification">
          <template slot="label">
            <el-popover placement="top" width="160" trigger="hover">
              <el-button type="primary" size="mini" @click="toViewOpenState()">点击查看开户资质说明</el-button>
              <div slot="reference">资质证明<i class="el-icon-question"></i></div>
            </el-popover>
          </template>
          <upload-img
            @delete="handleDelete"
            @upload="handleUpload"
            sign="qualification"
            :multiple="true"
            :imgs="productForm.qualification"
          ></upload-img>
        </el-form-item>
      </el-form>
    </product-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import ProductDialog from '@/components/FormDialog';
import CircleBlue from '@/assets/image/icon/circle-blue.png';
import CircleOrange from '@/assets/image/icon/circle-orange.png';
import CirclePurple from '@/assets/image/icon/circle-purple.png';
import CircleGreen from '@/assets/image/icon/circle-green.png';
import UploadImg from '@/components/UploadImg';
import $util from '@/common/js/util';

const req = new Request();
const REVIEW_STATUS_ENUM = {
  DELETE: 0,
  DOING: 1,
  PASS: 2,
  REJECT: 3
};

export default {
  name: 'productManage',
  components: {
    ProductDialog,
    UploadImg
  },
  data() {
    return {
      stat: {},
      circleBlue: CircleBlue,
      circleOrange: CircleOrange,
      circlePurple: CirclePurple,
      circleGreen: CircleGreen,
      REVIEW_STATUS_ENUM: REVIEW_STATUS_ENUM,
      keyword: '',
      status: '',
      statusOptions: [
        {
          status: 1,
          label: '审核中'
        },
        {
          status: 2,
          label: '通过'
        },
        {
          status: 3,
          label: '驳回'
        }
      ],
      tableLoading: false,
      tableData: [],
      tableColumns: [
        {
          key: 'product_name',
          name: '产品名称'
        },
        {
          key: 'product_url',
          name: '产品链接'
        },
        {
          key: 'product_company',
          name: '广告主公司名称'
        },
        {
          key: 'qualification',
          name: '资质证明',
          minWidth: 205
        },
        {
          key: 'reason',
          name: '修改意见'
        },
        {
          key: 'status',
          name: '状态'
        }
      ],
      page: 1,
      page_size: 10,
      total: 0,
      showProductModifyDialog: false,
      productForm: {
        product_name: '',
        product_url: '',
        product_company: '',
        qualification: []
      },
      targetItem: {}
    };
  },

  computed: {
    perms() {
      return this.$store.state.perms;
    },

    canproductList() {
      return this.perms.includes('productList');
    },

    canproductAdd() {
      return this.perms.includes('productAdd');
    },

    canproductEdit() {
      return this.perms.includes('productEdit');
    },
  },

  methods: {
    async getProductList() {
      try {
        this.tableLoading = true;
        let params = {
          keyword: this.keyword,
          status: this.status,
          page: this.page,
          page_size: this.page_size
        };
        const res = await req.send(req.Apis.sales.customer.applyProductList, params);
        this.stat = res.data.stat;
        this.tableData = res.data.list;
        this.total = Number(res.data.total);
        this.tableLoading = false;
      } catch (err) {
        this.tableLoading = false;
        this.$message.error(`获取产品列表失败：${err.message || '未知错误'}`);
      }
    },
    modifyProduct(item) {
      this.targetItem = item;
      this.showProductModifyDialog = true;
      this.$nextTick(() => {
        this.productForm.product_name = item.product_name;
        this.productForm.product_url = item.product_url;
        this.productForm.product_company = item.product_company;
        this.productForm.qualification = item.qualification ? item.qualification.split(',') : [];
      });
    },
    async submitProduct() {
      try {
        if (!this.productForm.product_name || !this.productForm.product_url || !this.productForm.product_company) {
          this.$message.error('请填写必要信息!');
          return;
        }
        let params = {
          product_name: this.productForm.product_name,
          product_url: this.productForm.product_url,
          product_company: this.productForm.product_company,
          qualification: this.productForm.qualification.join(','),
          needStringify: true
        };
        let url = req.Apis.sales.customer.applyProductAdd;
        let message = '新增产品成功';
        if (this.targetItem.id) {
          params.id = this.targetItem.id;
          url = req.Apis.sales.customer.applyProductUpdate;
          message = '修改产品成功';
        }
        await req.send(url, params);
        this.showProductModifyDialog = false;
        this.$message.success(message);
        this.getProductList();
      } catch (err) {
        this.$message.error(`更新产品失败：${err.message || '未知错误'}`);
      }
    },
    addProduct() {
      if (this.$refs.productForm) {
        // 清除校验结果
        this.$refs.productForm.resetFields();
      }
      this.targetItem = {};
      this.productForm.product_name = '';
      this.productForm.product_url = '';
      this.productForm.product_company = '';
      this.productForm.qualification = [];
      this.showProductModifyDialog = true;
    },
    addAdvertiser() {
      this.$router.push({
        name: 'AdvertiserManagePrivateAddAder'
      });
    },
    handlePaginationSizeChange(size) {
      this.page_size = size;
      this.getProductList();
    },
    handlePaginationCurrentChange(current) {
      this.page = current;
      this.getProductList();
    },
    // 监听图片删除
    handleDelete(res = {}) {
      const { imgs, sign } = res;
      this.productForm[sign] = [...imgs];
    },
    // 监听图片上传
    handleUpload(res) {
      const { imgs, sign } = res;
      this.productForm[sign] = [...imgs];
    },
    // 查看资质说明
    toViewOpenState() {
      $util.openUrl('/help/qualification', { newWin: true });
    },
    // 返回列表中资质图片的样式
    qualificationStyle(url) {
      return {
        background: `url(${url}) no-repeat center center /cover`,
        display: 'inline-block',
        width: '50px',
        height: '50px',
        'margin-right': '5px',
        'margin-left': '5px',
        'box-shadow': '0px 0px 8px 0px rgba(32, 45, 112, 0.1), 0px 0px 2px 0px rgba(32, 45, 112, 0.04)'
      };
    }
  },
  created() {
    this.getProductList();
  }
};
</script>
<style lang="less" scoped>
.product-manage {
  .top-area {
    .item {
      // width:254px;
      position: relative;
      box-sizing: border-box;
      height: 90px;
      padding: 12px 16px 16px 16px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(32, 45, 112, 0.1), 0px 0px 2px 0px rgba(32, 45, 112, 0.04);
      border-radius: 8px;
      p {
        margin: 0;
      }

      .label {
        color: #909399;
        font-size: 14px;
        margin-bottom: 4px;
        padding-top: 1px;
      }
      .value {
        font-size: 14px;
        color: #373c40;

        span {
          font-size: 36px;
          color: #303133;
          margin-right: 4px;
        }
      }
      .r-img {
        position: absolute;
        top: 0;
        right: 0;
        height: 90px;
        .bg-img {
          height: 90px;
        }
      }
    }
  }
  .query-area {
    margin: 24px 0;
    .el-input,
    .el-select {
      margin-right: 24px;
    }
  }
  .pagination {
    float: right;
    margin-top: 20px;
  }
}
</style>
